import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import type { Dayjs } from 'dayjs';
import { memo } from 'react';
import { SelectMember } from '../select-member';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditUsageFiltersProps as Props } from './types';
import { useCreditUsageFilters } from './use-credit-usage-filters';

const DATE_PICKER_SLOT_PROPS = { desktopPaper: { sx: SX.desktopPaper } };

export const CreditUsageFilters = memo(({ className }: Props) => {
  const {
    data,
    startDateValue,
    endDateValue,
    onStartDateChange,
    onEndDateChange,
    shouldDisableDate,
  } = useCreditUsageFilters();

  if (!data) {
    return null;
  }

  return (
    <Styled.Wrapper
      className={classnames('CreditUsageFilters', className)}
      sx={SX.root}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <>
        <Stack direction="row" gap={1}>
          <Styled.DatePicker
            value={startDateValue}
            slotProps={DATE_PICKER_SLOT_PROPS}
            shouldDisableDate={(day) => shouldDisableDate(day as Dayjs)}
            onChange={onStartDateChange}
          />
          <Styled.DatePicker
            value={endDateValue}
            slotProps={DATE_PICKER_SLOT_PROPS}
            onChange={onEndDateChange}
          />
        </Stack>
        <SelectMember />
      </>
    </Styled.Wrapper>
  );
});

CreditUsageFilters.displayName = 'CreditUsageFilters';
